import React, { useState } from "react";
import { useEffect } from "react";
import reqFuncionario from "../../../services/reqFuncionario";
import api from "../../../services/api";

const ListFilterCaixaColaborador = (props) => {
	const [listFuncionario, setListFuncionario] = useState([]);

	useEffect(() => {
		if (!props.isSelectCaixa) {
			listarColaboradores();
		}
	}, [props.isSelectCaixa]);

	async function listarColaboradores() {
		const response = await reqFuncionario.listar(api, "", "");

		setListFuncionario(response.data);
	}

	function handleSelectChange(e) {
		const selectedIndex = e.target.selectedIndex;
		const selectedOptionText = e.target.options[selectedIndex].text;
		const selectedId = e.target.value;
		if (props.setNomeOuColaborador) props.setNomeOuColaborador(selectedOptionText);

		props.setIdCaixaOuColaborador(e.target.value);
	}

	function AlterarTipoDePesquisa() {
		props.setIsSelectCaixa(!props.isSelectCaixa);
		if (props.isSelectCaixa) {
			props.setIdCaixaOuColaborador(0);
		} else props.setIdCaixaOuColaborador(1);
	}

	return (
		<div className="row col-12">
			<div className="d-flex">
				<div className="col-6">
					{props.isSelectCaixa ? (
						<div className="form-group">
							<label htmlFor="meuSelect1">Número do caixa</label>
							{/* <select className="form-control" id="meuSelect1" onChange={(e) => props.setIdCaixaOuColaborador(e.target.value)} value={props.idCaixaOuColaborador}> */}
							<select className="form-control" id="meuSelect1" onChange={handleSelectChange} value={props.idCaixaOuColaborador}>
								<option key={1} value={1}>
									1
								</option>
								<option key={2} value={2}>
									2
								</option>
								<option key={3} value={3}>
									3
								</option>
								<option key={4} value={4}>
									4
								</option>
								<option key={5} value={5}>
									5
								</option>
								<option key={6} value={6}>
									6
								</option>
								<option key={7} value={7}>
									7
								</option>
								<option key={8} value={8}>
									8
								</option>
								<option key={9} value={9}>
									9
								</option>
								<option key={10} value={10}>
									10
								</option>
								<option key={11} value={"%"}>
									TODOS
								</option>
							</select>
						</div>
					) : (
						<div className="mb-3">
							<small className="text-secondary">Colaborador</small>
							<select name="colaborador" id="colaborador" className="form-select" onChange={handleSelectChange} value={props.idCaixaOuColaborador} required>
								{/* <select name="colaborador" id="colaborador" className="form-select" onChange={(e) => props.setIdCaixaOuColaborador(e.target.value)}  required></select> */}
								<option value="0">Selecione o colaborador</option>
								{listFuncionario.map((c) => {
									return (
										<option key={c.id_funcionario} value={c.id_funcionario}>
											{c.nome}
										</option>
									);
								})}
							</select>
							<div className="valid-feedback">Validado!</div>
							<div className="invalid-feedback">Por favor escolha a forma de pagamento</div>
						</div>
					)}
				</div>
				{!props.hideToggle && (
					<div className="d-flex justify-content-between align-items-center ms-3 mt-4">
						<div className="form-check form-switch">
							<input className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" checked={props.isSelectCaixa} onChange={(e) => AlterarTipoDePesquisa()} />
							<label className="form-check-label" htmlFor="flexSwitchCheckDefault">
								Número do caixa ou nome colaborador
							</label>
						</div>
					</div>
				)}
			</div>
		</div>
	);
};
export default ListFilterCaixaColaborador;
